
<agpr-dialog-container
    [id]="id"
    [heading]="heading"
    (close)="cancel()"
>
    <div
        class="agpr-saveStylesDialog-content"
        role="radiogroup"
        [attr.aria-labelledby]="'SaveStylesDialog.dialogTitle'"
    >
        <div class="agpr-saveStylesDialog-inputGroup">
            <agpr-radio
                [id]="id + '_createRadioBtn'"
                class="agpr-saveStylesDialog-radio"
                [value]="saveStateType.new"
                [(ngModel)]="saveType"
                (ngModelChange)="saveTypeUpdated($event)"
                label="Styles.saveStylesDialog.saveAsNewLabel"
                hiddenLabel="Styles.saveStylesDialog.saveAsNewLabel"
                name="saveState"
            ></agpr-radio>
            @if (saveType === saveStateType.new) {
                <agpr-text-input
                    [id]="id + '_newStyleNameInput'"
                    class="agpr-saveStylesDialog-newNameInput"
                    [(ngModel)]="newStyleName"
                    (ngModelChange)="validate()"
                    [placeholder]="'Styles.saveStylesDialog.saveAsNewPlaceholder' | localize"
                    maxlength="64"
                    [bottomMargin]="false"
                ></agpr-text-input>
            }

            @if (showError) {
                <div class="agpr-saveStylesDialog-duplicateNameError">
                    <agpr-form-message [marginBottom]="0">
                        {{ 'Styles.manageDialog.error.duplicateName.message' | localize : {name: duplicateStyleName} }}
                    </agpr-form-message>
                </div>
            }
        </div>

        <div class="agpr-saveStylesDialog-inputGroup">
            <agpr-radio
                [id]="id + '_updateRadioBtn'"
                class="agpr-saveStylesDialog-radio"
                [value]="saveStateType.update"
                [(ngModel)]="saveType"
                (ngModelChange)="saveTypeUpdated($event)"
                label="Styles.saveStylesDialog.updateExistingLabel"
                hiddenLabel="Styles.saveStylesDialog.updateExistingLabel"
                name="saveState"
            ></agpr-radio>
            @if (saveType === saveStateType.update) {
                <agpr-dropdown
                    [id]="id + '_updateDropdown'"
                    placeholder="Styles.saveStylesDialog.updateExistingPlaceholder"
                    [options]="existingStyleDropdownOptions"
                    ariaLabel="Styles.saveStylesDialog.updateExistingLabel"
                    [(ngModel)]="selectedStyleOption"
                    (ngModelChange)="onDropdownChanged($event.value)"
                ></agpr-dropdown>
            }
        </div>
    </div>

    <ng-template #footerLeft>
        <div>
            <agpr-button
                [id]="id + '_cancelBtn'"
                label="Styles.saveStylesDialog.cancelLabel"
                [style]="buttonTypes.secondary"
                (click)="cancel()"
            ></agpr-button>
        </div>
    </ng-template>
    <ng-template #footerRight>
        <div>
            <agpr-button
                [id]="id + '_okBtn'"
                [style]="buttonTypes.primary"
                [label]="okLabel"
                [disabled]="!formValid"
                (click)="ok()"
            ></agpr-button>
        </div>
    </ng-template>
</agpr-dialog-container>
